import { FormControl } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  '& .MuiFormControl-root': {
    backgroundColor: theme.palette.background.paper,
  },
  '& .MuiFormLabel-root.MuiInputLabel-root': {
    paddingLeft: 8,
    paddingRight: 8,
    backgroundImage: `linear-gradient(to bottom, transparent 50%, ${theme.palette.background.paper} 50%)`,
    color: theme.palette.text.secondary,
    '&.Mui-error': {
      color: theme.palette.error.main,
    },
  },
  '& .MuiFormControl-root.MuiTextField-root .MuiOutlinedInput-root.Mui-focused fieldset': {
    // TODO: no VDS token for this value — needs designer input (#00b5e299 secondary with opacity)
    borderColor: '#00b5e299',
    borderWidth: 2,
  },
  '& .MuiFormControl-root.MuiTextField-root .MuiOutlinedInput-root fieldset': {
    borderWidth: '1px',
    // TODO: no VDS token for this value — needs designer input (rgba(0,0,0,0.23))
    borderColor: 'rgba(0, 0, 0, 0.23)',
  },
  '& .Mui-error': {
    '& fieldset': {
      borderColor: `${theme.palette.error.main} !important`,
    },
  },
}));
